import { Location } from '../models/location.interface';

export const locationMocks: Location = {
  label: 'Location',
  placeholder: 'Destination',
  accessibilityLocation: 'Search available stay location'
};
